<template>
    <div class="mylogin-pc">
      <!-- 左侧装饰区域 -->
      <div class="login-decoration">
        <div class="decoration-content">
          <div class="brand-logo">
            <i class="el-icon-s-marketing"></i>
            <span>桩交所</span>
          </div>
          <h1 class="slogan">充电桩信息发布管理平台</h1>
          <p class="sub-slogan">高效 · 智能 · 可信赖</p>
          <div class="feature-list">
            <div class="feature-item">
              <i class="el-icon-check"></i>
              <span>资产全生命周期管理</span>
            </div>
            <div class="feature-item">
              <i class="el-icon-check"></i>
              <span>实时收益数据分析</span>
            </div>
            <div class="feature-item">
              <i class="el-icon-check"></i>
              <span>多维度财务报表</span>
            </div>
          </div>
        </div>
        <!-- 装饰图形 -->
        <div class="decoration-shapes">
          <div class="shape shape-1"></div>
          <div class="shape shape-2"></div>
          <div class="shape shape-3"></div>
        </div>
      </div>
  
      <!-- 右侧登录区域 -->
      <div class="login-area">
        <div class="login-container">
          <!-- 登录表单 -->
          <div class="login-box" v-if="showType === 'login'">
            <div class="login-header">
              <h2 class="login-title">欢迎登录</h2>
              <p class="login-subtitle">请使用您的账号密码登录系统</p>
            </div>
            
            <el-form 
              :model="loginForm" 
              :rules="rules" 
              ref="loginForm" 
              class="login-form"
              @keyup.enter.native="submitForm('loginForm')"
            >
              <el-form-item prop="mobile">
                <div class="input-label">手机号</div>
                <el-input 
                  v-model="loginForm.mobile" 
                  placeholder="请输入手机号"
                  clearable
                  class="login-input"
                >
                  <i slot="prefix" class="el-icon-mobile-phone"></i>
                </el-input>
              </el-form-item>
              
              <el-form-item prop="password">
                <div class="input-label">密码</div>
                <el-input 
                  v-model="loginForm.password" 
                  placeholder="请输入密码"
                  show-password
                  clearable
                  class="login-input"
                >
                  <i slot="prefix" class="el-icon-lock"></i>
                </el-input>
              </el-form-item>
  
              <div class="form-options">
                <el-checkbox v-model="savePassword" class="remember-check">
                  记住密码
                </el-checkbox>
                <el-button type="text" class="forgot-link" @click="editPassword">
                  忘记密码？
                </el-button>
              </div>
  
              <el-button 
                type="primary" 
                class="login-btn" 
                :loading="loading"
                @click.native.prevent="submitForm('loginForm')"
              >
                立即登录
              </el-button>
  
              <!-- <div class="register-tip">
                还没有账号？<el-button type="text" @click="goRegister">立即注册</el-button>
              </div> -->
            </el-form>
          </div>
  
          <!-- 忘记密码 -->
          <div class="login-box" v-else-if="showType === 'editPasswrod'">
            <div class="login-header">
              <h2 class="login-title">忘记密码</h2>
              <p class="login-subtitle">请验证身份后重置密码</p>
            </div>
            <le-edit-password type="forgetPass" @toLogin="toLogin"></le-edit-password>
            <div class="back-login">
              <el-button type="text" @click="showType = 'login'">
                <i class="el-icon-arrow-left"></i> 返回登录
              </el-button>
            </div>
          </div>
  
          <!-- 选择商户 -->
          <!-- <div class="login-box company-box" v-else-if="showType === 'loginCompany'">
            <div class="login-header">
              <h2 class="login-title">选择登录商户</h2>
              <p class="login-subtitle">请选择您要管理的商户账号</p>
            </div>
            
            <div class="company-list">
              <div 
                class="company-item" 
                v-for="(item, index) in companyList" 
                :key="index" 
                @click="handleLoginCompany(item)"
              >
                <div class="company-icon">
                  <i class="el-icon-office-building"></i>
                </div>
                <div class="company-info">
                  <div class="company-brand">{{ item.brand || item.name }}</div>
                  <div class="company-name">{{ item.name }}</div>
                </div>
                <div class="company-arrow">
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
            </div>
  
            <div class="back-login">
              <el-button type="text" @click="showType = 'login'">
                <i class="el-icon-arrow-left"></i> 返回登录
              </el-button>
            </div>
          </div> -->
        </div>
  
        <!-- 底部版权 -->
        <!-- <div class="login-footer">
          <p>© 2026 星火伙伴 版权所有</p>
        </div> -->
      </div>
    </div>
  </template>
  
  <script>
  import validate from '../../utils/validate'
  import util from '../../utils/index'
  import { mapActions, mapState } from 'vuex'
  import leEditPassword from '../components/page/le-edit-password.vue'
  
  export default {
    components: {
      leEditPassword
    },
    data() {
      var validatePhone = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入手机号'))
        } else if (!validate.isvalidPhone(value)) {
          callback(new Error('请输入正确的手机号'))
        } else {
          callback()
        }
      }
      return {
        showType: 'login',
        loginForm: {
          mobile: '',
          password: ''
        },
        rules: {
          mobile: [{ validator: validatePhone, trigger: 'blur' }],
          password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
        },
        savePassword: false,
        companyList: [],
        loading: false
      }
    },
    computed: {
      ...mapState({
        company: state => state.company.company,
        user: state => state.user.user
      })
    },
    mounted() {
      this.getSaveAccount()
      if (util.getCookie('password')) {
        this.savePassword = true
      }
    },
    methods: {
      ...mapActions({
        getUserInfo: 'user/getUserInfo',
        getDefaultCompanyInfo: 'company/getDefaultCompanyInfo'
      }),
  
      getSaveAccount() {
        if (document.cookie.length > 0) {
          this.loginForm.mobile = util.getCookie('mobile') || ''
          this.loginForm.password = util.getCookie('password') || ''
        }
      },
  
      submitForm(formName) {
        this.$refs[formName].validate(async valid => {
          if (valid) {
            await this.login()
          } else {
            return false
          }
        })
      },
  
      async login() {
        this.loading = true
        try {
          const { data } = await this.$Axios._post({
            url: this.$Config.apiUrl.mobileLogin,
            params: {
              phone: this.loginForm.mobile,
              password: new (require('md5.js'))().update(this.loginForm.password).digest('hex')
            },
            loadingMessage: '正在登录...'
          })
  
          this.$Utils.setToken(data.token, 7)
          util.setCookie('mobile', this.loginForm.mobile, 7)
          
          if (this.savePassword) {
            util.setCookie('password', this.loginForm.password, 7)
          } else {
            util.setCookie('password', '', -1)
          }
  
          await this.getUserInfo()
        //   this.companyList = await this.getBusinessDatas()
          
        //   if (!this.companyList.length) {
        //     this.$Utils.removeToken()
        //     this.$message.error('暂无商户权限')
        //     this.loading = false
        //     return
        //   }
  
        //   if (this.companyList.length > 1) {
        //     this.showType = 'loginCompany'
        //     this.loading = false
        //     return
        //   }
  
        //   const chooseCompanyResult = await this.changeBusiness(this.companyList[0])
        //   if (!chooseCompanyResult) {
        //     this.$Utils.removeToken()
        //     this.$message.error('登录商户失败')
        //     this.loading = false
        //     return
        //   }
  
          this.$router.push({ path: '/demand/index' })
        } catch (error) {
          console.error(error)
        } finally {
          this.loading = false
        }
      },
  
      async handleLoginCompany(datas) {
        const chooseCompanyResult = await this.changeBusiness(datas)
        if (!chooseCompanyResult) {
          this.$Utils.removeToken()
          this.$message.error('登录商户失败')
          return
        }
        this.$router.push({ path: '/underlying/index' })
      },
  
      getBusinessDatas() {
        return new Promise((resolve, reject) => {
          this.$Axios._get({
            url: this.$Config.apiUrl.getCompanyChooseList,
            method: 'get'
          }).then(({ data }) => {
            const companyList = data.filter(item => item.status === 1)
            resolve(companyList)
          }).catch(() => {
            resolve([])
          })
        })
      },
  
      changeBusiness(datas) {
        return new Promise((resolve, reject) => {
          this.$Axios._get({
            url: this.$Config.apiUrl.chooseCompany,
            method: 'get',
            params: { companyId: datas.id }
          }).then(() => {
            resolve(1)
          }).catch(() => {
            resolve(0)
          })
        })
      },
  
      editPassword() {
        this.showType = 'editPasswrod'
      },
  
      toLogin(e) {
        this.showType = 'login'
        if (e === 'success') {
          this.loginForm.mobile = ''
          this.loginForm.password = ''
        }
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .mylogin-pc {
    display: flex;
    min-height: 100vh;
    background: #f5f7fa;
  
    // 左侧装饰区域
    .login-decoration {
      flex: 1;
      background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
      position: relative;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 60px;
  
      .decoration-content {
        position: relative;
        z-index: 2;
        max-width: 480px;
        color: #fff;
  
        .brand-logo {
          display: flex;
          align-items: center;
          gap: 16px;
          margin-bottom: 48px;
  
          i {
            font-size: 48px;
            opacity: 0.9;
          }
  
          span {
            font-size: 32px;
            font-weight: 700;
            letter-spacing: 2px;
          }
        }
  
        .slogan {
          font-size: 42px;
          font-weight: 700;
          margin-bottom: 16px;
          line-height: 1.2;
        }
  
        .sub-slogan {
          font-size: 20px;
          opacity: 0.8;
          margin-bottom: 48px;
          font-weight: 300;
        }
  
        .feature-list {
          .feature-item {
            display: flex;
            align-items: center;
            gap: 12px;
            margin-bottom: 20px;
            font-size: 16px;
  
            i {
              width: 24px;
              height: 24px;
              background: rgba(255, 255, 255, 0.2);
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 12px;
            }
          }
        }
      }
  
      // 装饰图形
      .decoration-shapes {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        pointer-events: none;
  
        .shape {
          position: absolute;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.05);
        }
  
        .shape-1 {
          width: 600px;
          height: 600px;
          top: -200px;
          right: -200px;
        }
  
        .shape-2 {
          width: 400px;
          height: 400px;
          bottom: -100px;
          left: -100px;
        }
  
        .shape-3 {
          width: 200px;
          height: 200px;
          top: 40%;
          right: 10%;
          background: rgba(255, 255, 255, 0.08);
        }
      }
    }
  
    // 右侧登录区域
    .login-area {
      width: 666px;
      background: #fff;
      display: flex;
      flex-direction: column;
      position: relative;
  
      .login-container {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 40px;
      }
  
      .login-box {
        width: 100%;
        max-width: 500px;
  
        .login-header {
          text-align: center;
          margin-bottom: 40px;
  
          .login-title {
            font-size: 28px;
            font-weight: 700;
            color: #111827;
            margin-bottom: 8px;
          }
  
          .login-subtitle {
            font-size: 14px;
            color: #6b7280;
          }
        }
      }
  
      .login-form {
        .input-label {
          font-size: 14px;
          font-weight: 500;
          color: #374151;
          margin-bottom: 8px;
        }
  
        ::v-deep .el-form-item {
          margin-bottom: 24px;
  
          &:last-child {
            margin-bottom: 0;
          }
        }
  
        ::v-deep .el-input__inner {
          height: 48px;
          border-radius: 8px;
          border: 1px solid #e8ecf4;
          padding-left: 40px;
          font-size: 14px;
          transition: all 0.3s;
  
          &:focus {
            border-color: #3b82f6;
            box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
          }
  
          &::placeholder {
            color: #9ca3af;
          }
        }
  
        ::v-deep .el-input__prefix {
          left: 12px;
          
          i {
            font-size: 18px;
            color: #9ca3af;
            line-height: 48px;
          }
        }
  
        .form-options {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 24px;
  
          .remember-check {
            ::v-deep .el-checkbox__label {
              font-size: 14px;
              color: #6b7280;
            }
  
            ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
              background-color: #3b82f6;
              border-color: #3b82f6;
            }
          }
  
          .forgot-link {
            font-size: 14px;
            color: #3b82f6;
  
            &:hover {
              color: #2563eb;
            }
          }
        }
  
        .login-btn {
          width: 100%;
          height: 48px;
          font-size: 16px;
          font-weight: 500;
          border-radius: 8px;
          background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
          border: none;
          margin-bottom: 24px;
          transition: all 0.3s;
  
          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 20px rgba(59, 130, 246, 0.3);
          }
  
          &:active {
            transform: translateY(0);
          }
        }
  
        .register-tip {
          text-align: center;
          font-size: 14px;
          color: #6b7280;
  
          .el-button {
            font-size: 14px;
            color: #3b82f6;
            font-weight: 500;
          }
        }
      }
  
      // 商户选择
      .company-box {
        .company-list {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }
  
        .company-item {
          display: flex;
          align-items: center;
          gap: 16px;
          padding: 20px;
          background: #f8fafc;
          border: 1px solid #e8ecf4;
          border-radius: 12px;
          cursor: pointer;
          transition: all 0.3s;
  
          &:hover {
            background: #eff6ff;
            border-color: #bfdbfe;
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(59, 130, 246, 0.1);
          }
  
          .company-icon {
            width: 48px;
            height: 48px;
            background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            font-size: 24px;
          }
  
          .company-info {
            flex: 1;
  
            .company-brand {
              font-size: 16px;
              font-weight: 600;
              color: #111827;
              margin-bottom: 4px;
            }
  
            .company-name {
              font-size: 13px;
              color: #6b7280;
            }
          }
  
          .company-arrow {
            color: #9ca3af;
            font-size: 16px;
          }
        }
      }
  
      .back-login {
        margin-top: 24px;
        text-align: center;
  
        .el-button {
          color: #6b7280;
          font-size: 14px;
  
          i {
            margin-right: 4px;
          }
  
          &:hover {
            color: #3b82f6;
          }
        }
      }
  
      .login-footer {
        padding: 24px;
        text-align: center;
        border-top: 1px solid #f3f4f6;
  
        p {
          font-size: 13px;
          color: #9ca3af;
          margin: 0;
        }
      }
    }
  }
  
  // 响应式适配
  @media (max-width: 992px) {
    .mylogin-pc {
      .login-decoration {
        display: none;
      }
  
      .login-area {
        width: 100%;
      }
    }
  }
  </style>